module.exports = __webpack_public_path__ + "img/1@2x.1f152db0.png";